import { resolveEndpoint } from '../endpointUtils';

export default {
	authorisation: {
		uri: '/ibapi/v2/banks/:bankId/user/:scopeId/authorisation',
		x_bpi_version: '1.2.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	transaction: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/transactions',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	mandate: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/so',
		x_bpi_version: '1.0.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	updateMandate: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/so/:mandateId',
		x_bpi_version: '1.0.0',
		method: 'PUT',
		resolve(bankId, scopeId, accountId, mandateId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId, mandateId });
		},
	},
	submitBatch: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/transactions/batch',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, ScopeId) {
			return resolveEndpoint(this.uri, { bankId, ScopeId });
		},
	},
	storeTransaction: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/transactions/store',
		x_bpi_version: '0.8.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	storeSo: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/so/store',
		x_bpi_version: '1.0.0',
		method: 'POST',
		resolve(bankId, scopeId, accountId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId });
		},
	},
	cancelPaymentApproval: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/payment/:paymentId',
		x_bpi_version: '1.3.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId, paymentId) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId, paymentId });
		},
	},
	getStandingOrders: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/so?record_type=:mandateRecordType&start_index=:mandateStartIndex&max_records=:mandateMaxRecords',
		x_bpi_version: '1.0.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId, mandateRecordType, mandateStartIndex, mandateMaxRecords) {
			return resolveEndpoint(this.uri, {
				bankId,
				scopeId,
				accountId,
				mandateRecordType,
				mandateStartIndex,
				mandateMaxRecords,
			});
		},
	},
	getDirectDebits: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/dd?record_type=:mandateRecordType&start_index=:mandateStartIndex&max_records=:mandateMaxRecords',
		x_bpi_version: '1.0.0',
		method: 'GET',
		resolve(bankId, scopeId, accountId, mandateRecordType, mandateStartIndex, mandateMaxRecords) {
			return resolveEndpoint(this.uri, {
				bankId,
				scopeId,
				accountId,
				mandateRecordType,
				mandateStartIndex,
				mandateMaxRecords,
			});
		},
	},
	cancelPayments: {
		uri: '/ibapi/v2/banks/:bankId/accounts/:scopeId/:accountId/mandates/:mandateType/:paymentId',
		x_bpi_version: '1.0.0',
		method: 'DELETE',
		resolve(bankId, scopeId, accountId, paymentId, mandateType) {
			return resolveEndpoint(this.uri, { bankId, scopeId, accountId, paymentId, mandateType });
		},
	},
};
